import { defineStore } from 'pinia'
import api from '../api/http'

export const useAuth = defineStore('auth', {
  state: () => ({ 
    user: null, 
    loading: false, 
    csrfToken: null 
  }),
  getters: { isAuthed: (s) => !!s.user },
  actions: {
    async login(username, password) {
      this.loading = true
      try {
        const { data } = await api.post('/auth/login', { username, password })
        if (data.csrfToken) {
          this.csrfToken = data.csrfToken
          
          api.defaults.headers.common['X-CSRF-Token'] = data.csrfToken
        }
        await this.check()
        return true
      } catch (e) { 
        return false 
      } finally { 
        this.loading = false 
      }
    },
    async logout() {
      await api.post('/auth/logout')
      this.user = null
      this.csrfToken = null
      delete api.defaults.headers.common['X-CSRF-Token']
    },
    async check() {
      try { 
        const { data } = await api.get('/auth/me')
        this.user = data 
      } catch (e) { 
        this.user = null 
      }
    }
  }
})

// export const useAuth = defineStore('auth', {
//   state: () => ({ user: null, loading: false }),
//   getters: { isAuthed: (s) => !!s.user },
//   actions: {
//     async login(username, password) {
//       this.loading = true
//       try {
//         await api.post('/auth/login', { username, password })
//         await this.check()
//         const { data } = await api.get('/csrf-token')
//         api.defaults.headers.common['X-CSRF-Token'] = data.csrfToken
//         return true
//       } catch (e) { 
//         return false 
//       } finally { 
//         this.loading = false 
//       }
//     },
//     // async login(username, password) {
//     //   this.loading = true
//     //   try {
//     //     await api.post('/auth/login', { username, password })
//     //     await this.check()
//     //     return true
//     //   } catch (e) { return false }
//     //   finally { this.loading = false }
//     // },
//     async logout() {
//       await api.post('/auth/logout'); this.user = null
//     },
//     async check() {
//       try { const { data } = await api.get('/auth/me'); this.user = data }
//       catch (e) { this.user = null }
//     }
//   }
// })
